import { ILabJobScopedFact, ITimestampedFact } from './common';

export interface ILabJobReceivedFact
  extends ILabJobScopedFact,
    ITimestampedFact {
  isOverdue: boolean;
  overdueBy?: number;
  requiredForAppointment: boolean;
  timeUntilAppointment?: number;
}
